// extracted by mini-css-extract-plugin
export default {"wallpaper":"acBDIeOX2Yz9K11QqF9L"};